import { CONNECTION_TYPE_DISPLAY_VALUES } from "./constants";

export const convertCelsiusToFahrenheit = (celsius) => {
  const fahrenheit = (celsius * 9) / 5 + 32;
  return Math.round(fahrenheit);
};

export const convertFahrenheitToCelsius = (fahrenheit) => {
  return parseFloat((((fahrenheit - 32) * 5) / 9).toFixed(2));
};

export const getConnectionTypeLabel = (connectionType) => {
  if (!connectionType) {
    return "";
  }

  return Object.prototype.hasOwnProperty.call(CONNECTION_TYPE_DISPLAY_VALUES, connectionType)
    ? CONNECTION_TYPE_DISPLAY_VALUES[connectionType]
    : connectionType;
};

export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? "").trim());

export const getUserDisplayName = (user) => {
  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim();
  return fullName || "--";
};
